import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    index: 0,
    dialogOpen: false
}

const pageIndexSlice = createSlice({
    name: 'pageIndex',
    initialState,
    reducers: {
        setPage(state, action) {
            state.index = action.payload
        },
        setDialogOpen(state, action) {
            state.dialogOpen = action.payload
        }
    }
})

export const { setPage, setDialogOpen } = pageIndexSlice.actions
export default pageIndexSlice.reducer